<template>
  <div>
    <quill-editor
            ref="myQuillEditor"
            v-model="contentHtml"
            :options="editorOption"
            @change="onEditorChange($event)"
    />
  </div>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor';
export default {
  components: {
    quillEditor
  },
  props: ['content'],
  data() {
    return {
      contentHtml: this.content,
      editorOption: {}
    };
  },
  beforeDestroy() {
    // this.editor.destroy();
  },
  methods: {
    onEditorChange({ html, text }) {
      this.$emit('change', { html, text });
    }
  },
};
</script>

<style lang="scss">
  .ProseMirror {
    text-align: start;
  }
</style>
